import { PREFIX } from '~constants/fullstory';

// FullStory page-visit attribution events for marketing (COS-4646).
export const MarketingAttributionEvents = {
	// Pickup & Delivery / Dispatch
	FS_PUD_DISPATCH_DASHBOARD: `${PREFIX} PUD Dispatch Dashboard`,
	FS_PUD_COMMERCIAL_CUSTOMERS: `${PREFIX} PUD Commercial Customers`,
	FS_PUD_COMMERCIAL_ORDERS: `${PREFIX} PUD Commercial Orders`,

	// Cents Assist
	FS_ASSIST_MESSENGER_ROOT: `${PREFIX} Assist Messenger`,
	FS_ASSIST_MESSENGER_INBOX: `${PREFIX} Assist Messenger Inbox`,
	FS_ASSIST_CALL_CENTER: `${PREFIX} Assist Call Center`,
	FS_ASSIST_CALL_CENTER_CALLS: `${PREFIX} Assist Call Center Calls`,
	FS_ASSIST_SETTINGS: `${PREFIX} Assist Settings`,
	FS_ASSIST_MESSENGER_NOTIFICATIONS: `${PREFIX} Assist Messenger Notifications`,

	// Accelerate / Marketing Tools
	FS_ACCELERATE_MARKETING_ROOT: `${PREFIX} Accelerate Marketing`,
	FS_ACCELERATE_MARKETING_BLASTS: `${PREFIX} Accelerate Marketing Blasts`,
	FS_ACCELERATE_PROMOTIONS_SETTINGS: `${PREFIX} Accelerate Promotions Settings`,
	FS_ACCELERATE_TASK_MANAGER: `${PREFIX} Accelerate Task Manager`,
	FS_ACCELERATE_REFERRAL_PROGRAM: `${PREFIX} Accelerate Referral Program`,
	FS_ACCELERATE_LOYALTY_PROGRAM: `${PREFIX} Accelerate Loyalty Program`,
} as const;
